// src/components/Header.jsx

import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = ({ onToggleSidebar }) => {

  const [user] = useState({
    name: "Admin User"
  });

  const [notificationCount] = useState(3);

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    return parts.length > 1
      ? (parts[0][0] + parts[1][0]).toUpperCase()
      : parts[0][0].toUpperCase();
  };

  const initials = getInitials(user?.name);

  const logout = () => {
    alert("Logged Out");
  };

  return (

    <header className="header">

      <div className="header__left">

        <button
          className="header__toggle"
          onClick={onToggleSidebar}
        >
          ☰
        </button>

        <h1 className="header__title">
          Subadmin Panel
        </h1>

      </div>

      <div className="header__right">

        <Link
          to="notifications"
          className="header__icon"
        >
          🔔

          {notificationCount > 0 && (
            <span className="header__badge">
              {notificationCount}
            </span>
          )}

        </Link>

        <div className="header__avatar-initials">
          {initials}
        </div>

        <button
          className="header__logout"
          onClick={logout}
        >
          Logout
        </button>

      </div>

    </header>

  );
};

export default Header;